import styles from './shopWithStock.module.scss';
import stylesLink from "../link/Link.module.scss";
import Link from '../link/Link';
import PropTypes from 'prop-types';

const ShopWithStock = ({ shopName, mapLink, onClickHandler, linkText, className }) => {
	return (
		<div className={className}>
			<div className={styles.store}>
				<span className={styles['store__icon']}></span>
				<span className={styles['store__name']}>{shopName.toLowerCase()}</span>{' '}
				{/* <span className={styles['store__stock_status']}>&nbsp;has stock</span> */}
			</div>
			<div className={`${styles.link} mt-s`}>
				{mapLink 
					? <Link text={linkText} href={mapLink} />
					: <div className={`regular-link ${stylesLink["link"]}`} onClick={onClickHandler}>{linkText}</div>
				}
			</div>
		</div>
	);
};

ShopWithStock.defaultProps = {
	shopName: '',
	linkText: 'Check at another store',
	className: '',
};

ShopWithStock.propTypes = {
	shopName: PropTypes.string,
	mapLink: PropTypes.string,
	linkText: PropTypes.string,
	className: PropTypes.string,
	onClickHandler: PropTypes.func
};

export default ShopWithStock;
